import React from 'react';
import {
  focusEditor,
  useEventPlateId,
  usePlateEditorRef,
  insertNodes,
  ELEMENT_PARAGRAPH,
} from '@udecode/plate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import clsx from 'clsx';

import { ToolbarButton } from './ToolbarButton';
import { ELEMENT_PAGE_BREAK } from '../../plugins/page-break/createPageBreakPlugin';

export const PageBreakButton = ({ id, ...props }) => {
  const editor = usePlateEditorRef(useEventPlateId(id));

  return (
    <ToolbarButton
      name="Insert page break"
      className={clsx('button--unstyled')}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();

        insertNodes(
          editor,
          [
            { type: ELEMENT_PAGE_BREAK, children: [{ text: '' }] },
            { type: ELEMENT_PARAGRAPH, children: [{ text: '' }] },
          ],
        );
        focusEditor(editor);
      }}
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      <FontAwesomeIcon icon={['fa', 'page-break']} />
    </ToolbarButton>
  );
};
